<template>
  <div class="assistant-card">
    <div class="vehicle-card__header">
      <strong>{{ title }}</strong>
      <span>{{ detail }}</span>
    </div>
    <label
      v-for="option in options"
      :key="option.key"
      class="vehicle-option"
      :class="{ 'is-selected': selectedKey === option.key }"
    >
      <input
        type="radio"
        :name="cardId"
        :checked="selectedKey === option.key"
        @change="$emit('select', option)"
      />
      <img v-if="option.image" :src="option.image" alt="" />
      <span class="vehicle-option__body">
        <span>{{ option.label }}</span>
        <span class="vehicle-option__meta">
          {{ option.engine }}
          <template v-if="option.family"> · {{ option.family }}</template>
        </span>
      </span>
    </label>
    <p v-if="total > options.length" class="vehicle-card__more">
      Y {{ total - options.length }} más: di el año o el motor para acotar.
    </p>
  </div>
</template>

<script>
// Vehículos de find_vehicle; el elegido filtra la búsqueda por texto
export default {
  name: "VehicleOptionsCard",
  props: {
    cardId: { type: String, required: true },
    title: { type: String, default: "" },
    detail: { type: String, default: "" },
    total: { type: Number, required: true },
    options: { type: Array, required: true },
    selectedKey: { type: String, default: null }
  }
};
</script>

<style lang="scss" scoped>
@import "./card.scss";

.vehicle-card__header {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
  span {
    font-size: 11px;
    color: #6b7280;
  }
}
.vehicle-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
  &.is-selected {
    border-color: #2563eb;
    background: #eff6ff;
  }
  img {
    width: 48px;
    height: 32px;
    object-fit: contain;
    flex-shrink: 0;
  }
}
.vehicle-option__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.vehicle-option__meta {
  font-size: 11px;
  color: #6b7280;
}
.vehicle-card__more {
  margin-top: 6px;
  font-size: 11px;
  color: #6b7280;
}
</style>
